import EpgEvent from '../../../classes/epgEvent';
import MainContext from '../context/mainContext';
import RegularEvent from '../../../classes/regularEvent';
import { MutableRefObject, useContext, useEffect, useState } from 'react';
import { channelsSelector } from '../../../store/slices/channels.slice';
import { useAppSelector } from '../../../store/hooks';

function useUpdateChannels({
  data,
  setListIndex,
  updateData,
}: {
  data: EpgEvent[];
  index?: number;
  setListIndex?: MutableRefObject<(index: number, increment?: number) => void>;
  updateData: (
    newData: (EpgEvent | RegularEvent | undefined)[],
    resetStyle?: boolean
  ) => void;
}) {
  const { channelsData } = useAppSelector(channelsSelector);
  const [finalEvents, setFinalEvents] = useState(data);
  const { setAsset } = useContext(MainContext);

  useEffect(() => {
    if (channelsData?.length) {
      const firstEvent = finalEvents[0]?.id;
      const sortedEvents = finalEvents?.sort((item1, item2) => {
        return (
          channelsData?.findIndex((ch) => item1.channel?.code === ch.code) -
          channelsData?.findIndex((ch) => item2.channel?.code === ch.code)
        );
      });
      const channelChanged =
        sortedEvents?.length && firstEvent !== sortedEvents[0]?.id;
      setTimeout(() => {
        if (setListIndex?.current && channelsData.length && channelChanged) {
          setListIndex.current(0, 0);
          setTimeout(() => {
            updateData(sortedEvents, true);
            setAsset(sortedEvents[0]);
          });
        }
      });
      updateData(sortedEvents);
      setFinalEvents(sortedEvents);
    }
  }, [channelsData, data, finalEvents]);

  useEffect(() => {
    setFinalEvents(data);
  }, [data]);

  return finalEvents;
}

export default useUpdateChannels;
